<content class="dx-field-value dx-validator dx-visibility-change-handler dx-show-invalid-badge dx-textbox dx-texteditor dx-editor-outlined dx-widget">
  <div class="dx-texteditor-container">
    <div class="dx-texteditor-input-container">
      <input class="dx-texteditor-input" type="tel" [id]="inputId" [ngClass]="inputClass" [pattern]="pattern" [(ngModel)]="value"
      [required]="required" [placeholder]="placeholder" (keyup)="cleanValue()"
      (ngModelChange)="valueChanged($event)" [disabled]="disabled" [ngClass]="inputClass">
    </div>
  </div>
</content>